<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.taxes') }} > {{ this.$route.query.tax_name }}
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="tax !== null"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section class="choose-type">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.selecttype')"/>
            <div class="row wrapper">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-12">
                    <vs-radio
                      v-model="form.formType"
                      :vsValue="TAX_FORM_TYPE.TAX"
                      :disabled="true"
                      color="#A3CA76"
                      style="float: left;padding: 0;">
                      <strong>
                        {{ $t('apps.product.message.typetax') }}
                      </strong>
                    </vs-radio>
                  </div>
                  <div
                    class="form-check-label"
                    style="margin-left: 25px;">
                    <p>
                      {{ $t('apps.product.message.typetaxdetail') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-12">
                    <vs-radio
                      v-model="form.formType"
                      :vsValue="TAX_FORM_TYPE.SERVICE_CHARGE"
                      :disabled="true"
                      color="#A3CA76"
                      style="float: left;padding: 0;">
                      <strong>
                        {{ $t('apps.product.message.typeservicecharge') }}
                      </strong>
                    </vs-radio>
                  </div>
                  <div
                    class="form-check-label"
                    style="margin-left: 25px;">
                    <p>
                      {{ $t('apps.product.message.typeservicechargedetail') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-12">
                    <vs-radio
                      v-model="form.formType"
                      :vsValue="TAX_FORM_TYPE.FEE"
                      :disabled="true"
                      color="#A3CA76"
                      style="float: left;padding: 0;">
                      <strong>
                        {{ $t('apps.product.message.typefee') }}
                      </strong>
                    </vs-radio>
                  </div>
                  <div
                    class="form-check-label"
                    style="margin-left: 25px;">
                    <p>
                      {{ $t('apps.product.message.typefeedetail') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.general')"/>
            <div class="form-row">
              <div class="col-md-6 mb-mobile-2">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.tax_name') }} *</label>
                    <input
                      v-if="tax.deletable"
                      ref="tax_name"
                      :class="['form-control tax-name', { 'is-invalid': $v.form.tax_name.$error }]"
                      v-model="$v.form.tax_name.$model"
                      :disabled="disabledForm"
                      type="text">
                    <input
                      v-else
                      :class="['form-control tax-name']"
                      :value="getMasterDataText(tax.tax_name, $t)"
                      :disabled="true"
                      type="text">
                  </div>
                </div>
              </div>
              <div
                v-if="[TAX_FORM_TYPE.TAX].includes(form.formType)"
                class="col-md-6">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.tax_amount') }} *</label>
                    <div class="input-group">
                      <input
                        ref="amount"
                        v-model="form.amount"
                        :disabled="disabledForm"
                        type="text"
                        class="form-control text-right number-only text-select-all"
                        style="border-right: 0;"
                        @keypress="numberOnly"
                        @keyup="form.amount = setToValidNumber(form.amount)">
                      <div class="input-group-prepend">
                        <button
                          :disabled="disabledForm || tax.deletable === false"
                          class="btn dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style="border: 1px solid #ced4da;">
                          <template v-if="form.type == 'exclude'">
                            {{ $t('message.tax_exclude') }}
                          </template>
                          <template v-if="form.type == 'include'">
                            {{ $t('message.tax_include') }}
                          </template>
                        </button>
                        <div class="dropdown-menu">
                          <a
                            class="dropdown-item"
                            @click="form.type = 'exclude'">{{ $t('message.tax_exclude') }}</a>
                          <a
                            class="dropdown-item"
                            @click="form.type = 'include'">{{ $t('message.tax_include') }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="col-md-6">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.tax_amount') }} *</label>
                    <div>
                      <input
                        ref="amount"
                        v-model="form.amount"
                        :disabled="disabledForm"
                        type="text"
                        class="form-control text-right number-only text-select-all"
                        @keypress="numberOnly"
                        @keyup="form.amount = setToValidNumber(form.amount)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="[TAX_FORM_TYPE.FEE].includes(form.formType)"
              class="row mt-3"
            >
              <div class="col-6">
                <label>
                  {{ $t('apps.product.message.calculatedfrom') }} *
                </label>
                <div class="form-row">
                  <div class="col-6">
                    <select
                      v-model="$v.form.feeCalcType.$model"
                      :class="['custom-select form-control', { 'is-invalid': $v.form.feeCalcType.$error }]"
                      :disabled="disabledForm"
                    >
                      <option :value="null">
                        {{ $t('placeholder.select') }}
                      </option>
                      <option :value="FEE_CALC_TYPE.NET">
                        {{ $t('apps.product.message.calctypenet') }}
                      </option>
                      <option :value="FEE_CALC_TYPE.CUSTOM">
                        {{ $t('apps.product.message.calctypecustom') }}
                      </option>
                    </select>
                  </div>
                  <div
                    v-if="form.feeCalcType === FEE_CALC_TYPE.CUSTOM"
                    class="col-6">
                    <select
                      v-model="$v.form.feeCalcTaxId.$model"
                      :class="['custom-select form-control', { 'is-invalid': $v.form.feeCalcTaxId.$error }]"
                      :disabled="disabledForm"
                    >
                      <option :value="null">
                        {{ $t('placeholder.select') }}
                      </option>
                      <option
                        v-for="(tax, index) in taxesNames"
                        :key="index"
                        :value="tax.id"
                      >
                        {{ tax.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mt-3">
          <div class="row">
            <div class="col-12">
              <section-header :title="$t('apps.product.message.advancedoptions')"/>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label>
                {{ $t('apps.product.message.group') }}
              </label>
              <div class="form-row">
                <div class="col-lg-6">
                  <vue-bootstrap-autocomplete
                    v-model="form.groupName"
                    :data="getTaxesGroupNames"
                    :minMatchingChars="1"
                    :showOnFocus="true"
                    :disabled="disabledForm"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isForSale"
                :disabled="true"
                :label="$t('apps.product.message.taxforsale')"
              />
            </div>
            <div
              v-if="[TAX_FORM_TYPE.TAX].includes(form.formType)"
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isForPurchase"
                :label="$t('apps.product.message.taxforpurchase')"
                :disabled="disabledForm"
              />
            </div>
            <div
              v-if="[TAX_FORM_TYPE.TAX].includes(form.formType)"
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isForExpense"
                :label="$t('apps.product.message.taxforexpense')"
              />
            </div>
            <!-- <div
              v-if="[TAX_FORM_TYPE.TAX].includes(form.formType)"
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isForPayroll"
                :label="$t('apps.product.message.taxforpayroll')"
              />
            </div> -->
            <div
              v-if="[TAX_FORM_TYPE.FEE].includes(form.formType)"
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isDisplayResult"
                :label="$t('apps.product.message.showfeeresult')"
                :disabled="disabledForm"
              />
            </div>
          </div>
        </section>

        <section
          class="assign-items mt-3"
          style="margin-bottom: 20px;">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignitems')"/>
            <BaseNotFoundData
              v-if="!products.length"
              :title="$t('apps.pos.message.notfoundproduct')"
              :detail="$t('apps.pos.message.createproduct')"
            />
            <base-assign-items
              v-else
              v-model="form.assignProductIds"
              :items="form.assignProductItems"
              :disabled="disabledForm"
            />
          </div>
        </section>

        <section class="mt-4">
          <div class="row">
            <div
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isActive"
                :label="form.isActive ? $t('message.enabled') : $t('message.disabled')"
                :disabled="disabledForm"
              />
            </div>
          </div>
        </section>

        <section class="mt-4">
          <div class="col-md-12 no-padding">
            {{ $t('message.applyitemtoapps', {item: $t('sidebar.taxes')}) }}
            <a
              href="https://www.treesoft.io/th/manual/product#tax"
              target="_blank">
              {{ $t('button.learnmore') }}
              <i class="fas fa-external-link-alt"/>
            </a>
          </div>
        </section>

        <section
          v-if="!disabledForm"
          class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              @click="save()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5
              v-if="tax"
              class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

    <BaseAlertModal
      :id="DELETE_DEFAULT_TAX_MODAL"
      :headerText="$t('message.notbeabletodeletedefaultdata')"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import { TAX_FORM_TYPE, FEE_CALC_TYPE } from '@/helpers/enum'
import { required } from 'vuelidate/lib/validators'
import { getMasterDataText } from '@/helpers'

export default {
  name: 'TaxEdit',
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      TAX_FORM_TYPE,
      FEE_CALC_TYPE,
      DELETE_DEFAULT_TAX_MODAL: 'DELETE_DEFAULT_TAX_MODAL',
      getMasterDataText,

      ready: false,

      form: {
        formType: TAX_FORM_TYPE.TAX,
        tax_name: '',
        amount: '0',
        type: 'exclude',
        groupName: null,
        isDisplayResult: false,
        isForSale: true,
        isForPurchase: true,
        isForExpense: false,
        isForPayroll: false,
        isActive: true,
        feeCalcType: null,
        feeCalcTaxId: null,
        assignProductIds: [],
        assignProductItems: [],
      },

      isSubmitted: false,
    }
  },
  validations: {
    form: {
      tax_name: {
        required,
      },
      feeCalcType: {
        requiredWithCondition: function(value) {
          if (this.form.formType === TAX_FORM_TYPE.FEE) {
            return !!value
          } else {
            return true
          }
        },
      },
      feeCalcTaxId: {
        requiredWithCondition: function(value) {
          if (this.form.formType === TAX_FORM_TYPE.FEE && this.form.feeCalcType === FEE_CALC_TYPE.CUSTOM) {
            return !!value
          } else {
            return true
          }
        },
      },
    },
  },
  computed: Object.assign(mapGetters({
    sidebar: 'getSidebar',
    products: 'getProducts',
    tax: 'getTax',
    currency: 'getCurrency',
    getTaxesGroupNames: 'getTaxesGroupNames',
    taxes: 'getTaxes',
  }), {
    dataSet () {
      let data = {
        tax_id: this.tax.tax_id,
        tax_name: this.form.tax_name,
        type: (() => {
          if (this.form.formType === TAX_FORM_TYPE.TAX) {
            return this.form.type
          }
          return 'exclude'
        })(),
        amount: parseInt(this.form.amount),
        group_name: !this.form.groupName ? null : this.form.groupName,
        is_display_fee_result: (() => {
          if (this.form.formType === TAX_FORM_TYPE.FEE) {
            return this.form.isDisplayResult
          }
          return true
        })(),
        is_for_sale: true,
        is_for_purchase: (() => {
          if (this.form.formType === TAX_FORM_TYPE.TAX) {
            return this.form.isForPurchase
          }
          return false
        })(),
        is_for_expense: (() => {
          if (this.form.formType === TAX_FORM_TYPE.TAX) {
            return this.form.isForExpense
          }
          return false
        })(),
        is_for_payroll: (() => {
          if (this.form.formType === TAX_FORM_TYPE.TAX) {
            return this.form.isForPayroll
          }
          return false
        })(),
        is_active: this.form.isActive,
      }
      if (this.form.formType === TAX_FORM_TYPE.FEE) {
        data['fee'] = {
          calc_type: this.form.feeCalcType,
          calc_tax_id: (() => {
            if (this.form.feeCalcType === FEE_CALC_TYPE.CUSTOM) {
              return this.form.feeCalcTaxId
            }
            return null
          })(),
        }
      }
      if (this.form.assignProductIds.length > 0) {
        data['assign'] = this.form.assignProductIds.map((id) => {
          return {
            product_id: id,
          }
        })
      }
      return data
    },
    taxesNames() {
      return this.taxes
        .filter((tax) => tax.tax_id != this.$route.query.tax_id)
        .map((tax) => {
          return {
            id: tax.tax_id,
            name: tax.tax_name,
          }
        })
    },
    disabledForm () {
      return !this.hasRoleEdit
    },
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
  },
  created: async function () { // call api to get data and set state
    /**
     *  validation
     */
    if (!this.$route.query.tax_id) {
      return this.$router.push({ name: 'TaxAll' })
    }
    // get tax
    let res = await this.fetchData()
    if (!res.success) {
      return this.$router.push({ name: 'TaxAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'TaxAll' })
    }
    /**
     *  validation success
     */
    // get products
    await this.$store.dispatch('getProducts')
    // get taxes
    await this.$store.dispatch('getTaxes')
    // get taxes group names
    await this.$store.dispatch('getTaxesGroupNames')
    // set data
    this.setData()
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 8,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 6, [{
      'name': this.$route.query.tax_name,
      'router': {
        'name': 'TaxEdit',
        'query': {
          tax_id: this.$route.query.tax_id,
          tax_name: this.$route.query.tax_name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 6,
      submenuAtIdx: 2,
    })
  },
  mounted: function () { // run script
    // set popup modal
    this.setModal('#confirmdeleteModal')
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts', 'clearTax'])
  },
  methods: {
    setData() {
      this.form.formType = this.tax.form_type
      this.form.tax_name = this.tax.tax_name
      this.form.type = this.tax.type
      this.form.amount = this.setToCustomDigitsNumber(this.tax.amount.toString())
      this.form.groupName = this.tax.group_name
      this.form.isDisplayResult = this.tax.is_display_fee_result
      this.form.isForSale = this.tax.is_for_sale
      this.form.isForPurchase = this.tax.is_for_purchase
      this.form.isForExpense = this.tax.is_for_expense
      this.form.isForPayroll = this.tax.is_for_payroll
      this.form.isActive = this.tax.is_active
      this.form.feeCalcType = this.tax.fee ? this.tax.fee.calc_type : null
      this.form.feeCalcTaxId = this.tax.fee ? this.tax.fee.calc_tax_id : null

      this.form.assignProductIds = this.tax.assign.map((v) => v.product_id)
      this.form.assignProductItems = []
      for (const product of this.products) {
        const item = {
          text: product.product_name,
          value: product.product_id,
        }
        this.form.assignProductItems.push(item)
      }
    },
    fetchData() {
      return this.$store.dispatch('getTax', {
        tax_id: this.$route.query.tax_id,
      })
    },
    async save () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return false
      }

      this.isSubmitted = true

      let res = await this.$store.dispatch('updateTax', this.dataSet)

      if (res.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.form.tax_name }),
          color: 'success',
          icon: 'save',
        })

        await this.fetchData()
        await this.$store.dispatch('getProducts')

        this.isSubmitted = false
        this.showFinish(this.$Progress)
      }
    },
    async del () {
      let data = {
        tax_id: this.tax.tax_id,
      }

      let res = await this.$store.dispatch('deleteTax', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.form.tax_name }),
          color: 'danger',
          icon: 'delete',
        })
        // close modal
        this.closeConfirmdeleteModal()
        // go to GoodsIssueAll page
        return this.$router.push({ name: 'TaxAll' })
      }
    },
    openConfirmdeleteModal () {
      console.log('this.tax', this.tax)
      if (!this.tax.deletable) {
        $(`#${this.DELETE_DEFAULT_TAX_MODAL}`).modal('show')
      } else {
        $('#confirmdeleteModal').modal('show')
      }
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/accounts/tax/Edit.vue